import { Controller } from "@hotwired/stimulus"

// Global function for opening delete modal
window.openDeleteModal = function(inloopId, inloopName) {
  console.log("Opening delete modal", { inloopId, inloopName })

  const modal = document.getElementById("delete-inloop-modal")
  const nameElement = modal.querySelector('[data-delete-modal-target="inloopName"]')
  const formElement = modal.querySelector('[data-delete-modal-target="form"]')

  if (nameElement) {
    nameElement.textContent = inloopName
  }

  if (formElement) {
    formElement.action = `/facilitator/inloops/${inloopId}`
  }

  modal.classList.remove("hidden")
  document.body.style.overflow = "hidden"
}

export default class extends Controller {
  static targets = ["inloopName", "form"]

  open(event) {
    console.log("Delete modal open() called", event)
    event.preventDefault()
    event.stopPropagation()

    const inloopName = event.currentTarget.dataset.inloopName
    const inloopId = event.currentTarget.dataset.inloopId
    console.log("Inloop details:", { inloopName, inloopId })

    window.openDeleteModal(inloopId, inloopName)
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    const modal = document.getElementById("delete-inloop-modal")
    modal.classList.add("hidden")
    document.body.style.overflow = ""
  }

  // Close on ESC key
  connect() {
    this.escapeHandler = (event) => {
      if (event.key === "Escape") {
        this.close()
      }
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler)
  }
}
